import React from "react";
import { Link } from "react-router-dom";
import { deliveryText, getTableName, paymentText } from "../../../lang/orders";
import { formatNumber } from "../../../middleware/common-functions";
import { toDate } from "../../../middleware/dates";
import { lang } from "../../../middleware/lang";
import { OrderType } from "../../../models/order_model";
import { SalesDBType } from "../../../models/sales_model";

type SalesOrdersProps = {
  sales_data: SalesDBType;
  onDownload?: () => void;
};

const SalesOrders: React.FC<SalesOrdersProps> = ({ sales_data, onDownload }) => {
  return (
    <>
      {onDownload && (
        <div className="d-flex justify-content-end mb-2">
          <button className="btn btn-outline-secondary btn-sm" onClick={onDownload}>
            <i className="fa fa-download mr-1" />
            {lang("Descargar CSV", "Download CSV")}
          </button>
        </div>
      )}
      <OrderGroup orders={sales_data.orders} />
    </>
  );
};

type GroupProps = {
  orders: OrderType[];
};

const OrderGroup: React.FC<GroupProps> = ({ orders }) => (
  <div className="row mt-3">
    <div className="col-12">
      <div className="table-responsive">
        <table className="table table-hover light_table show_on_new">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">{lang("Fecha", "Date")}</th>
              <th scope="col">{lang("Hora", "Time")}</th>
              <th scope="col">{lang("Productos", "Products")}</th>
              <th scope="col" className="sm_hidden">
                {lang("Persona", "Person")}
              </th>
              <th scope="col" className="sm_hidden">
                {lang("Pago", "Payment")}
              </th>
              <th scope="col" className="sm_hidden">
                {lang("Mesa", "Table")}
              </th>
              <th scope="col" className="sm_hidden">
                {lang("Tipo", "Type")}
              </th>
              <th scope="col" className="sm_hidden">
                {lang("Envio", "Delivery")}
              </th>
              <th scope="col" className="sm_hidden">
                {lang("Propina", "Tip")}
              </th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody id="order_list">
            {orders
              ? orders.map((item, key) => (
                  <List key={`${key}_${item.id}`} item={item} />
                ))
              : null}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

type ListProps = {
  item: OrderType;
};

const List: React.FC<ListProps> = ({ item }) => {
  const delivery = deliveryText(item.delivery_type, item.platform_name);
  const payment = paymentText(item.payment_type);
  const table_name = getTableName(item.table);
  const userName = item.user
    ? `${item.user.name} ${item.user.lastname || ""}`.trim()
    : "—";

  return (
    <tr data-order_id={item.id}>
      <td className="order_id_row">
        <b>
          <Link to={`/order/${item.id}`}>{item.id}</Link>
        </b>
      </td>
      <td>{toDate(item.creation_date, {}, "date")}</td>
      <td>{toDate(item.creation_date, {}, "hour")}</td>
      <td>{item.resume_txt}</td>
      <td className="sm_hidden">{userName}</td>
      <td className="sm_hidden">{payment.txt}</td>
      <td className="table_row_id sm_hidden">{table_name}</td>
      <td className="sm_hidden">{delivery.txt}</td>
      <td className="sm_hidden">
        {item.delivery ? `$${formatNumber(item.delivery)}` : "—"}
      </td>
      <td className="sm_hidden">
        {item.tip ? `$${formatNumber(item.tip)}` : "—"}
      </td>
      <td>
        <b>${formatNumber(item.total)}</b>
      </td>
    </tr>
  );
};

export default SalesOrders;
